import React, { Component } from "react";
import Select from "react-select";
import { InputGroup, FormControl, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import DeleteConfirmForm from "../settings/DeleteConfirmForm";
import { addEventNameToEndpoint } from "../../utils/common";
import "./CreateWish.scss";

const ReactSwal = withReactContent(Swal);

class CreateWish extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: props.editWish ? props.editWish.title : '',
      contentType: props.editWish ? props.editWish.contentType : '',
      urgency: props.editWish ? props.editWish.urgency : null,
      revenueImpact: props.editWish && props.editWish.revenueImpact ? props.editWish.revenueImpact.replace('$', '') : 0,
      why: props.editWish ? props.editWish.why : '',
      description: props.editWish ? props.editWish.description : '',
      error: null
    }

    this.typeOptions = Object.keys(this.props.contentTypes).map(key => ({
      value: key, label: key
    }));
    this.typeOptions.push({ value: 'Other', label: 'Other' });

    this.urgencyOptions = Object.keys(this.props.wishlistUrgency).map(key => ({
      value: key, label: this.props.wishlistUrgency[key].name
    }));
  }

  handleFormSubmit = (id) => {
    addEventNameToEndpoint(this.props.Analytics, this.props.editWish ? 'btnSaveWish' : 'btnAddWish');
    
    const {
      title,
      contentType,
      urgency,
      revenueImpact,
      why,
      description
    } = this.state;

    if (!urgency || urgency === 0) {
      this.setState({ error: 'Please select urgency.' });
      return;
    } else if (!contentType || contentType === '') {
      this.setState({ error: 'Please select content type.' });
      return;
    } else if (title === '') {
      this.setState({ error: 'Please input title.' });
      return;
    } else if (why === '') {
      this.setState({ error: 'Please input because.' });
      return;
    }

    if (!this.props.editWish) {
      if (revenueImpact !== 0) {
        this.props.addWish({
          title,
          contentType,
          urgency,
          why,
          revenueImpact: '$' + revenueImpact,
          description,
          status: 'Wished'
        });
      } else {
        this.props.addWish({
          title,
          contentType,
          urgency,
          why,
          description,
          status: 'Wished'
        });
      }
    } else {
      this.props.updateWish(this.props.editWish.id, {
        title,
        contentType,
        urgency,
        why,
        revenueImpact: '$' + revenueImpact,
        description
      });
    }

    this.props.onClose();
  }

  deleteWish = () => {
    addEventNameToEndpoint(this.props.Analytics, 'user-wishlistItem-delete');

    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <DeleteConfirmForm
          type='wish'
          data={this.props.editWish}
          onClose={ReactSwal.clickCancel}
          onConfirm={ReactSwal.clickConfirm}
        />
      )
    })
    .then(result => {
      if (result.value) {
        this.props.deleteWish(this.props.editWish.id);
        this.props.onClose();
      }
    });
  }

  render() {
    return (
      <div className="create-wish-container">
        <p className="title">CONTENT REQUEST</p>
        <div className="content-block d-flex">
          {'I '}
          <Select
            className="basic-single urgency"
            classNamePrefix="select"
            name="color"
            placeholder="Urgency"
            options={this.urgencyOptions}
            value={this.state.urgency !== null ? { value: this.state.urgency, label: this.props.wishlistUrgency[this.state.urgency].name } : null}
            onChange={(sel) => this.setState({ urgency: sel.value })}
          />
          {' a '}
          <Select
            className="basic-single content-type"
            classNamePrefix="select"
            name="color"
            placeholder="Select Content Type"
            options={this.typeOptions}
            value={this.state.contentType ? { value: this.state.contentType, label: this.state.contentType } : null}
            onChange={(sel) => this.setState({ contentType: sel.value })}
          />
        </div>
        <div className="content-block">
          <InputGroup>
            <FormControl
              aria-label="title"
              aria-describedby="wish-title"
              value={this.state.title}
              onChange={(e) => this.setState({ title: e.target.value })}
              placeholder="...title of content item ..."
            />
          </InputGroup>
        </div>
        <div className="content-block d-flex">
          <span>because</span>
          <InputGroup>
            <FormControl
              aria-label="why"
              aria-describedby="wish-why"
              value={this.state.why}
              onChange={(e) => this.setState({ why: e.target.value })}
              placeholder="...what propted the ask?"
            />
          </InputGroup>
        </div>
        <div className="content-block">
          <p>and needs to:</p>
          <InputGroup>
            <FormControl
              as="textarea"
              rows="5"
              value={this.state.description}
              placeholder="...contain these key points or look like this, to be successful..."
              onChange={(e) => this.setState({ description: e.target.value })}
            />
          </InputGroup>
        </div>
        <div className="content-block d-flex revenue">
          <span className="desc">with revenue impact over 12mos of (optional)</span>
          <InputGroup>
            <InputGroup.Prepend>
              <InputGroup.Text id="impact-price">$</InputGroup.Text>
            </InputGroup.Prepend>
            <FormControl
              aria-label="impact"
              aria-describedby="impact-price"
              value={this.state.revenueImpact}
              onChange={(e) => this.setState({ revenueImpact: e.target.value })}
            />
          </InputGroup>
        </div>
        {this.state.error && <p className="error">{this.state.error}</p>}
        <div className={`content-block buttons ${this.props.editWish ? 'edit' : ''}`}>
          {this.props.editWish &&
            <a
              className="delete-wish"
              id="btnDeleteWish"
              href="#"
              onClick={this.deleteWish}
              data-cc-analytics-on='click'
              data-cc-analytics-name='user-wishlistItem-delete'
              data-cc-analytics-attrs={`id:${this.props.editWish.id},name:${this.props.editWish.title},userId:${this.props.editWish.requestedBy}`}
            >
              Delete Wish
            </a>
          }
          <div>
            <Button variant="outline-danger" className="btn btn-outline-danger mr-3" onClick={this.props.onClose}>CANCEL</Button>
            <Button
              variant="outline-danger"
              className="btn btn-outline-danger"
              onClick={this.handleFormSubmit}
              data-cc-analytics-on='click'
              id={this.props.editWish ? 'btnSaveWish' : 'btnAddWish'}
              data-cc-analytics-name={this.props.editWish ? 'user-wishlistItem-edit' : 'user-wishlistItem-add'}
              data-cc-analytics-attrs={this.props.editWish ? `name:${this.state.title},id:${this.props.editWish.id}` : `name:${this.state.title}`}
            >
              {this.props.editWish ? 'SAVE' : 'ADD WISH'}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default CreateWish;
